import { ContainerProgressCircle } from "components/waste-icons/svgs/ContainerProgressCircle";
import { BridgeWaterPercentageSVG } from "components/waste-icons/svgs";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DateDisplay from "components/datetime/DateDisplay";

const ContainerIconValuesBridge = ({ item, lastMeasure }) => {
    const [_Tc] = useTranslation("choices");
    return (
        <div className="row justify-content-center">
            <div className="col svg-filling p-0 text-center">
                <Link to={`/asset-management/containers/?uid=${item.uid}`} className="text-no-decoration" title="Ver puente">
                    <ContainerProgressCircle percent={(1 - lastMeasure / 400) * 100} type={item.waste_type} />
                </Link>
            </div>
            <div className="col-12 pt-2 date">
                <Link to={`/data-view/data-container/${item.uid}/`} className="text-no-decoration" title="Ver datos">
                    <div className="text-center no-decoration text-black small">
                        <DateDisplay date={item.measured_at} title={true} />
                    </div>
                </Link>
            </div>
        </div>
    );
};
export default ContainerIconValuesBridge;
